export const CUSTOMERS = "customers";
export const PAYMENT_METHODS = "paymentMethods";
export const INVOICES = "invoices";
export const INVOICE_LIMIT = 50;